import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CarFront, CalendarClock, UserRound, CreditCard } from "lucide-react";

export const CUSTOMER_TABS = [
  { key: "book", label: "Book a Ride", short: "Book", to: "/book", icon: CarFront },
  { key: "trips", label: "My Trips", short: "Trips", to: "/customer/trips", icon: CalendarClock },
  { key: "profile", label: "My Profile", short: "Profile", to: "/customer/profile", icon: UserRound },
  { key: "cards", label: "My Cards", short: "Cards", to: "/customer/cards", icon: CreditCard },
];

function activeKey(pathname) {
  if (pathname.startsWith("/book")) return "book";
  if (pathname.startsWith("/customer/profile")) return "profile";
  if (pathname.startsWith("/customer/cards")) return "cards";
  if (pathname.startsWith("/customer")) return "trips";
  return null;
}

/** Passenger dashboard navigation — segmented tab row on desktop,
 *  fixed bottom bar on phones. Render inside any page a logged-in client can reach. */
export default function CustomerNav({ mobileOnly = false }) {
  const { pathname } = useLocation();
  const active = activeKey(pathname);

  return (
    <>
      {/* Desktop / tablet: top tab row */}
      {!mobileOnly && (
      <nav data-testid="customer-nav-desktop" className="hidden md:flex border border-white/10 bg-[#0A0A0A] p-1 mb-10 w-fit">
        {CUSTOMER_TABS.map(t => {
          const Icon = t.icon;
          const on = active === t.key;
          return (
            <Link
              key={t.key}
              to={t.to}
              data-testid={`customer-tab-${t.key}`}
              aria-current={on ? "page" : undefined}
              className={`flex items-center gap-2 px-5 py-2.5 text-[11px] uppercase tracking-[0.18em] transition-colors ${on ? "bg-[#D4AF37] text-[#050505]" : "text-[#A1A1AA] hover:text-[#F5F2EB]"}`}
            >
              <Icon size={14}/> {t.label}
            </Link>
          );
        })}
      </nav>
      )}

      {/* Phone: fixed bottom bar */}
      <nav
        data-testid="customer-nav-mobile"
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-black/90 backdrop-blur-md border-t border-white/10"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="grid grid-cols-4">
          {CUSTOMER_TABS.map(t => {
            const Icon = t.icon;
            const on = active === t.key;
            return (
              <Link
                key={t.key}
                to={t.to}
                data-testid={`customer-tab-mobile-${t.key}`}
                aria-current={on ? "page" : undefined}
                className={`flex flex-col items-center justify-center gap-1 py-2.5 text-[9px] uppercase tracking-[0.16em] transition-colors ${on ? "text-[#D4AF37]" : "text-[#71717A]"}`}
              >
                <Icon size={20} strokeWidth={on ? 2.2 : 1.6}/>
                {t.short}
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
